<template>
  <z-table
    :fields="fields"
    :items="numbers"
    :show_header="true"
    :show_pagination_description="false"
    :show_per_page="false"
  >
    <template slot="actions">
      <table-control type="trash" />
    </template>
  </z-table>
</template>

<script>
  import { AmoService } from '@amo-widget/services/AmoService';

  export default {
    data() {
      return {
        numbers: []
      };
    },
    computed: {
      fields: function () {
        return [
          {
            key: 'number',
            label: this.$t('pbx.phone-list.form.field.phone'),
            sortable: false,
            thStyle: { width: '100%' }
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center disabled'
          }
        ];
      }
    },
    async mounted() {
      await AmoService.getSettingsData().then((response) => {
        this.numbers = response.numbers;
      });
    }
  };
</script>
